import React, { useState } from "react";

const ForgotPasswordForm = ({
  onSubmit,
  onBackToLogin,
  logoURL,
  clientDescription,
}) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Prevent accidental double submission
    if (isSubmitting) return;

    setIsSubmitting(true);
    setMessage(null);

    try {
      const result = await onSubmit(email);

      console.log("Forgot password result:", result);

      if (
        !result ||
        result.includes("Error") ||
        result.includes("Account has not been activated")
      ) {
        setMessage(
          "Error! Account has not been activated or there are multiple accounts with this email.",
        );
        setIsSuccess(false);
      } else {
        setMessage("Password reset email sent. Please check your inbox.");
        setIsSuccess(true);
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      setMessage(
        "Error! Account has not been activated or there are multiple accounts with this email.",
      );
      setIsSuccess(false);
    } finally {
      // Re-enable the button when the web service has finished
      setIsSubmitting(false);
    }
  };

  return (
    <div className="inner-form-container">
      <h2>{clientDescription}</h2>

      <img
        src={logoURL || "https://placehold.co/250x250/png"}
        alt="Brand Logo"
        className="branding-image"
      />

      <h2>Forgot Password</h2>
      <p>An email will be sent to you with a new temporary password.</p>

      {message && (
        <div className={isSuccess ? "success-box" : "error-box"}>{message}</div>
      )}

      <form onSubmit={handleFormSubmit} className="form">
        <label className="label">
          Email:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input"
            placeholder="you@example.com"
          />
        </label>

        <button type="submit" className="login-button" disabled={isSubmitting}>
          {isSubmitting ? "Sending..." : "Reset Password"}
        </button>

        <button
          type="button"
          onClick={onBackToLogin}
          className="register-button"
        >
          Back to Login
        </button>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
